import { IActionButtonCommonProps } from '../../typings/DocumentViewer/actionButtonCommonProps';
import ActionButton from './actionButton';
import { Icons } from 'copyright-clearance-center-common-ui';

export interface IEmailButtonBaseProps {
	orderUrl?: string;
	subject?: string;
	body?: string;
}

const EmailCitationButton: React.FunctionComponent<IEmailButtonBaseProps & IActionButtonCommonProps> = props => {
	const handler = () => {
		const params = new URLSearchParams();
		params.set('subject', encodeURIComponent(props.subject));
		params.set('body', encodeURIComponent(props.body) + encodeURIComponent(props.orderUrl));
		window.location.href = `mailto:?${decodeURIComponent(params.toString())}`;
	};

	return (
		<ActionButton
			label={localize('Email citation')}
			handler={handler}
			icon={Icons.MailIcon}
			isPrimary={props.isPrimary}
			testId="email-citation-btn"
			controlledBy={props.controlledBy}
		/>
	);
};

export default EmailCitationButton;
